import { createFileRoute } from "@tanstack/react-router";
import { prefetchUsageIfReadable } from "@/app/billing/usage-card-access";
import { Dashboard } from "@/app/dashboard/dashboard";
import { oauthProvidersCountQueryOptions } from "@/app/oauth/api/get-o-auth-providers-count";
import { secretsCountQueryOptions } from "@/app/secrets/api/get-secrets-count";
import { serversCountQueryOptions } from "@/app/servers/api/get-servers-count";
import { toolkitCollectionQueryOptions } from "@/app/tools/api/get-toolkit-collection";
import { toolsQueryOptions } from "@/app/tools/api/get-tools";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/home"
)({
  component: Dashboard,
  loader: ({ context: { queryClient }, params }) => {
    queryClient.prefetchQuery(
      toolsQueryOptions({ binding: "project", scope: params })
    );
    queryClient.prefetchQuery(toolkitCollectionQueryOptions(params));
    queryClient.prefetchQuery(
      oauthProvidersCountQueryOptions({ scope: params })
    );
    queryClient.prefetchQuery(serversCountQueryOptions({ scope: params }));
    queryClient.prefetchQuery(secretsCountQueryOptions({ scope: params }));
    prefetchUsageIfReadable(queryClient, params);
    return { crumb: "Dashboard" };
  },
});
